module.exports = __webpack_public_path__ + "ba0e7284123f2bd2c3bbfd7663c45248.svg";